export default __webpack_public_path__ + "users-module-empty-heading.png";